import { createTheme } from '@material-ui/core/styles';

const yellow = '#FBC143';
const blue = '#3E47E9';
const grey = '#646464';
const lightGrey = '#9C9C9C';
const gold = '#AF8D43';

export default createTheme({
  palette: {
    common: {
      yellow: yellow,
      blue: blue,
      grey: grey,
      gold: gold,
      lightGrey: lightGrey
    }
  },
  typography: {
    h1: {
      fontFamily: 'Cormorant Garamond, serif',
      fontWeight: 400,
      letterSpacing: 2,
      fontSize: '6rem'
    },
    h2: {
      fontFamily: 'Cormorant Garamond, serif',
      fontWeight: 400,
      // letterSpacing: 2,
      fontSize: '2.6rem',
      letterSpacing: 2,
      lineHeight: '2.8rem'
    },

    h4: {
      fontFamily: 'proximaNovaSB',
      fontSize: '2rem',
      lineSpacing: '2.6rem'
    },
    h5: {
      fontFamily: 'proximaNovaReg',
      fontSize: '1.5rem',
      lineSpacing: '1.87rem'
    },
    h6: {
      fontFamily: 'proximaNovaB',
      fontSize: 18,
      lineHeight: '20px'
    },

    body1: {
      fontFamily: 'proximaNovaReg',
      fontSize: '1.125rem',
      lineHeight: '1.75rem'
    },
    body2: {
      fontFamily: 'proximaNovaReg',
      fontSize: 14,
      lineHeight: '24px'
    },
    caption: {
      fontFamily: 'proximaNovaReg',
      fontSize: '10px',
      lineHeight: '14px'
    }
  },
  extraFonts: {
    insertTitle: {
      fontFamily: 'proximaNovaB',
      fontSize: '18px',
      lineHeight: '24px',
      textAlign: 'left'
    },
    pullQuote: {
      fontFamily: 'Cormorant Garamond, serif',
      fontSize: '50px',
      lineHeight: '52.5px',
      letterSpacing: '3.25px'
    },
    footNote: {
      fontFamily: 'proximaNovaReg',
      size: '14px',
      lineHeight: '30px',
      color: lightGrey
    }
  }
});
